import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { BackButton } from "../cta/cta";

interface fieldInterface {
  children: React.ReactNode;
  step: number;
  assignPostStep: (postStep: number) => void;
  onBack?: () => void;
  isFirstStep?: boolean;
}

export const FormCard = (props: fieldInterface) => {
  const { children, step, assignPostStep, onBack, isFirstStep } = props;
  const [cardVisibility, setCardVisibility] = useState("");

  useEffect(() => {
    if (step === -1) {
      setCardVisibility("hideFormCard");
      return;
    }

    // Smooth single transition: hide → update step → show
    setCardVisibility("hideFormCard");
    const timeoutId = setTimeout(() => {
      assignPostStep(step);
      setCardVisibility("showFormCard");
    }, 180);

    return () => clearTimeout(timeoutId);
  }, [step]);

  const shouldShowBackButton = onBack && isFirstStep !== true;

  return (
    <div className={`${styles.formCard} ${styles[cardVisibility]}`}>
      {shouldShowBackButton && <BackButton onClick={onBack} />}
      {children}
    </div>
  );
};
